import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";
import Authorization from "../../pages/Authorization/Authorization";
import MainScreen from "../../pages/MainScreen";
import Graph from "../../pages/Graph";
import ProfileCard from "../../pages/ProfileCard/ProfileCard";
import LoggedInLayout from "../../shared/components/LoggedInLayout";
import { RedirectAuthorization } from "../../shared/hoc";
import PageNotFound from "../../shared/Ui/PageNotFound/PageNotFound";
import PageErrorMessage from "../../shared/Ui/PageErrorMessage/PageErrorMessage";
import ProductCreate from "../../pages/ProductCreate/ProductCreate";
import OrderList from "../../pages/OrderList/OrderList";
import Orders from "../../pages/Orders/Orders";
import RegistrationTradePoint from "../../pages/RegistrationTradePoint/RegistrationTradePoint";
import InviteUser from "../../pages/InviteUser/InviteUser";
import AcceptInvitation from "../../pages/AcceptInvitation/AcceptInvitation";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/auth" element={<Authorization />} />
      <Route path="/accept-invitation/:token" element={<AcceptInvitation />} />

      <Route
        path="/"
        element={
          <RedirectAuthorization>
            <LoggedInLayout />
          </RedirectAuthorization>
        }
      >
        <Route index element={<MainScreen />} />
        <Route path="main" element={<Graph />} />
        <Route path="create" element={<ProductCreate />} />
        <Route path="organization" element={<MainScreen />} />
        <Route path="orders" element={<OrderList />} />
        <Route path="order/:DocumentId" element={<Orders />} />
        <Route path="order/catalog/:DocumentId" element={<MainScreen />} />
        <Route path="profile" element={<ProfileCard />} />
        <Route path="invite-user" element={<InviteUser />} />
        <Route path="tradePoints">
          <Route index element={<RegistrationTradePoint />} />
          <Route path=":tradePointId/invite-user" element={<InviteUser />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
        <Route path="/error" element={<PageErrorMessage />} />
      </Route>
      <Route path="/error" element={<PageErrorMessage />} />
      <Route path="*" element={<PageNotFound />} />
    </Route>
  ),
);
